import React from 'react'

import { BaseIconProps, IconSizes, IconColors } from '../base'

const Close: React.FC<BaseIconProps> = React.forwardRef(
  ({ size = 'md', color = 'default', className }, ref) => (
    <svg
      ref={ref}
      className={className}
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1L1 13"
        stroke={IconColors[color]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 13L1 1"
        stroke={IconColors[color]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

export default Close
